import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";

import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  moduleId: module.id,
  templateUrl: "ok.component.html",
})
export class PaymentOkComponent implements OnInit {
  model: any = {};
  loading = false;
  messages: any;
  isSuccess = false;
  okmessage: string;

  constructor(
    private router: Router,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  goToMain() {
    this.router.navigate(["/"]);
    // this.router.navigate(['/ok'], {queryParams: {success:true,authNumber:'12312312'}});
    // 		window.location.replace('#/ok?success=true&authNumber=55555');
  }

  ngOnInit() {
    //         this.dataService.clearCart().subscribe(d => {
    //
    //         });
    this.dataService.getUsersData(null).subscribe((data) => {});
    //  		this.alertService.success(this.activatedRoute.snapshot.queryParams ? JSON.stringify(this.activatedRoute.snapshot.queryParams) : 'nothing');
    if (
      this.activatedRoute.snapshot.queryParams &&
      this.activatedRoute.snapshot.queryParams.success
    ) {
      // 			this.alertService.success('התשלום נקלט בהצלחה ' + '<br/>קוד אישור ' + this.activatedRoute.snapshot.queryParams.authNumber);
      this.okmessage =
        "התשלום נקלט בהצלחה " +
        "<br/>קוד אישור " +
        this.activatedRoute.snapshot.queryParams.authNumber;
      this.isSuccess = true;
    } else if (
      this.activatedRoute.snapshot.queryParams &&
      this.activatedRoute.snapshot.queryParams.authNumber
    ) {
      this.dataService
        .okPayment(this.activatedRoute.snapshot.queryParams)
        .subscribe(
          (data) => {
            // 	            this.alertService.success(data && data.authNumber ? data.authNumber : JSON.stringify(data));
            // 				this.alertService.success('התשלום נקלט ההצלחה ' + this.activatedRoute.snapshot.queryParams.authNumber);
            this.okmessage =
              "התשלום נקלט בהצלחה " +
              "<br/>קוד אישור " +
              this.activatedRoute.snapshot.queryParams.authNumber;
            this.isSuccess = true;
            this.router.navigate(["/ok"]);
          },
          (error) => {
            this.alertService.error(error);
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/ok.component.ts